/*eslint-disable*/
import TicketApi from '../../api/communication/ticket';

export default {
    methods: {
        createTicket (form) {
            this.isLoading = true;
            let formData = new FormData();
            formData.append('body', form.body);
            formData.append('theme', form.theme);
            formData.append('department_id', form.department.id);
            if (form.recipient) {
                formData.append('recipientId', form.recipient.id);
            }
            form.files.forEach((element, index) => {
                formData.append(`files[${index}]`, element);
            });
            TicketApi.create(formData)
                .then(ticket => {
                    this.isLoading = false;
                    window.sessionStorage.removeItem(`ticketMessage`);
                    if (!ticket) {
                        return;
                    }
                    this.amountOfActive++;
                }).catch(() => {
                this.$toasted.error('Произошла ошибка при отправлении сообщения.');
                this.isLoading = false;
            });
        },
    }
}
